import React from 'react';
import { Opinion } from 'services';
import { Stack, FontIcon, Link, ILinkStyles, getTheme } from '@fluentui/react';
import { StyledMultiTag } from 'components/shared';

export interface ReviewOpinionBannerProps {
  opinion: Opinion;
  onUndoClick?: () => void;
}

const CardOpinionBanner: React.FunctionComponent<ReviewOpinionBannerProps> = props => {
  const { fonts, palette } = getTheme();

  const linkStyle: ILinkStyles = {
    root: {
      color: palette.themePrimary
    }
  };

  const messageStyle: React.CSSProperties = {
    backgroundColor: palette.white,
    fontSize: fonts.small.fontSize,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  };

  const iconStyle: React.CSSProperties = {
    fontSize: 36,
    color: palette.greenDark
  };

  const tags: string[] = Object.keys(props.opinion.opinionCategoryLabels).reduce<string[]>(
    (prev: string[], cur: string): string[] => {
      return [...prev, ...props.opinion.opinionCategoryLabels[cur]];
    },
    [] as string[]
  );
  return (
    <Stack className="w-100 h-100 position-absolute" style={{ zIndex: 1 }}>
      <Stack.Item className="h-100">
        <div style={messageStyle} className="h-100 text-center rounded">
          <div className="mt-auto mb-auto">
            <FontIcon iconName="Completed" style={iconStyle} className="w-100" />
            <div>Traits applied. </div>
            <Link onClick={props.onUndoClick} styles={linkStyle}>
              Undo
            </Link>
          </div>
        </div>
      </Stack.Item>
      <Stack.Item className="position-absolute mt-2 ml-2">
        <StyledMultiTag tags={tags} />
      </Stack.Item>
    </Stack>
  );
};

export default CardOpinionBanner;
